<template>
   <div style="height:100%;background:#fff" ref="container" class="dash-board">
      <div class="row" style="padding-bottom:20px">
        <div class="col-md-8">
          <span class="title"> Timesheets </span>
          <span class="add" style="font-size: 12px;color: #91959E;font-weight: 550;"><router-link :to="{name: 'employee-addtimesheets'}">
            Add Timesheets
            <i class="fa fa-long-arrow-right"></i>
          </router-link> </span>
        </div>
        <div class="col-md-4" style="z-index: 1;">
          <ob-select2  :inModal="false" :options="monthOptions" v-model.trim="MonthSelected" style="min-width: 100px;"></ob-select2>
        </div>
     </div>
     <div v-show="!isLoading" style="padding-bottom:20px">
      <ul class="clearfix list-unstyled list-inline dashboardcal-legends">
        <li class="legends">
          <span class="circle"></span>
          <span class="span_styles">PENDING LEAVE APPROVAL</span>
        </li>
        <li class="legends">
          <span class="circle6"></span>
          <span class="span_styles">REQUESTED FOR EDIT</span>
        </li>
        <li class="legends">
          <span class="circle1"></span>
          <span class="span_styles">TIME OFF</span>
        </li>
        <li class="legends">
          <span class="circle2"></span>
          <span class="span_styles">APPROVED</span>
        </li>
        <li class="legends">
          <span class="circle3"></span>
          <span class="span_styles">PENDING</span>
        </li>
        <li class="legends">
          <span class="circle4"></span>
          <span class="span_styles">REJECTED</span>
        </li>
         <li class="legends">
          <span class="circle5"></span>
          <span class="span_styles">IN-PROGRESS</span>
        </li>
        <li class="legends">
          <span class="circle7"></span>
          <span class="span_styles">INVOICE GENERATED</span>
        </li>
      </ul>
    </div>

    <template v-if="isLoading">
          <ob-spinner loading-text="Loading..."></ob-spinner>
    </template>
    <FullCalendar timeZone = "UTC" v-show="!isLoading" :height="height"  @renderEvent="renderEvent" @eventClick="eventClick" @dayRender="dayRender"  :aspectRatio="aspectRatio" @eventRender="eventRender" @eventSelected="eventSelected" @datesRender="datesRender" @eventPositioned="eventPositioned" class="ess-dashboard-calendar"  ref="fullCalendar" :titleFormat="titleFormat" :header="header" :defaultView="defaultView" :plugins="calendarPlugins" :weekends="weekends" :events="events"/>
    <approval-report :iframeURL="iframeURL" :fromTab="'timesheet'" :CanEvaluate="CanEvaluate" :CurrentView="defaultView" @approved="onTimeSheetApproved"  :selectedReport.sync="selectedEventInfo"  @openEvaluation="openEvaluation" :openModal.sync="openApprovalreport" :isSupervisor.sync="isSupervisor" ></approval-report>
    <evaluation-report :fromTab="'timesheet'" @approved="onTimeSheetApproved"  :selectedReport.sync="selectedEventInfo" :openModal.sync="openEvaluationReport" :isEdit="isEdit"></evaluation-report>
    <div ref="timeSheetPopoverWrapper" :class="eventObj.length == 1 && eventObj[0].CalendarType == 'Holiday' ? 'popover-custom-width-holiday' : eventObj.length == 1 && (eventObj[0].Status == 'Approved' || eventObj[0].ExpenseStatus == 'Approved') ?'popover-custom-width-Approved':'popover-custom-width-Pending'" class="timesheet-popover-wrapper" v-if="showTimeSheetsPopover" v-click-outside-for-dynamic-elements="closeTimeSheetsPopover">
      <TimeSheetPopover :EventInfo="eventObj" :CurrentView="defaultView" :IsEditTimesheetFlag="IsTimesheetEdit"></TimeSheetPopover>
    </div>
    <div>        
        <ob-modal2 :show.sync="showRequestForEditPopUp" :width="600">
          <div slot="modal-title">
              Specify a reason for edit request
          </div>
          <div slot="modal-body" style="text-align:center">
              <ob-textarea :maxLength="1200" style="width: 565px;height: 120px;resize:none;" v-model.trim="reasonForEdit" placeholder="Enter reason for edit request"></ob-textarea>
          </div>
          <template slot="modal-footer">
            <div slot="modal-soc--footer" style="text-align:center;">
              <ob-button type="secondary" style="width: 80px;height: 35px;" @click="closeEditRequestPopUp()">Cancel</ob-button>
              <ob-button type="primary" style="width: 100px;height: 35px;" :disabled="reasonForEdit == null || reasonForEdit == ''" @click="RequestToEdit()">Send Request</ob-button>
            </div>
          </template>
        </ob-modal2>
      </div>
  </div>
</template>
<script>
import moment from 'moment';
import { createPopper } from '@popperjs/core';
import ApprovalReport from '../Timesheets/ApprovalReport.vue'
import EvaluationReport from '../Timesheets/EvaluationReport.vue'
import TimeSheetPopover from '../Timesheets/Calender/TimeSheetPopover.vue'
import jquery from 'jquery'
import bootstrap from 'bootstrap';
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
const jqueryNearest = require('jquery-nearest')


export default {
  props:{
    weekends:{
      type:Boolean ,
      default: true
    },
    calendarPlugins:
    {
      type: Array,
      default() {
        return [ dayGridPlugin]
      }
    },
    defaultView :
    {
      type: String,
      default: "dayGridMonth"
    },
    IsTimesheetEdit : 
    {
      type: Boolean,
      default: false
    }
  },
  components: {
    FullCalendar ,
    TimeSheetPopover,
    "approval-report":ApprovalReport,
    "evaluation-report": EvaluationReport
  },
  data() {
    return {
        showTimeSheetsPopover: false,
        selectedEventInfo: {},
        eventObj:{},
        EventInfo:'',
        aspectRatio: 3.5,
        header: false,
        weekLabel:"narrow",
        columnFormat:'ddd d/M',
        titleFormat: {
          month: 'long',
          weekday: 'long'
        },
        // Approval Report
        CanEvaluate:true,
        isEdit:false,
        openApprovalreport:false,
        openEvaluationReport:false,
        iframeURL:'',

        monthOptions: {
        minimumResultsForSearch: -1,
        dropdownAutoWidth : true,
        placeholder: {
          id: "-1",
          text: "Select"
        },
        data: [{
            id:'01',text:'January'
          },
          {
            id:'02',text:'February'
          },
          {
            id:'03',text:'March'
          },
          {
            id:'04',text:'April'
          },
          {
            id:'05',text:'May'
          },
          {
            id:'06',text:'June'
          },
          {
            id:'07',text:'July'
          },
          {
            id:'08',text:'August'
          },
          {
            id:'09',text:'September'
          },
          {
            id:'10',text:'October'
          },
          {
            id:'11',text:'November'
          },
          {
            id:'12',text:'December'
          },
        ]
      },
        MonthSelected: moment().format('MM'),
        isLoading:false,
        showRequestForEditPopUp:false,
        reasonForEdit:'',
        empId:'',
        requestToEditType:'',
    }
  },
  watch:{
    MonthSelected(val)
    {   var year =  moment().format('YYYY');
        var farmattedDate = `${year}-${val}-01`;
        this.gotoDate(farmattedDate)
        this.height()
    },
  },
  computed: {
    EmployeeId()
    {
      return this.loggedInUserObj.empId ? this.loggedInUserObj.empId : '';
    },
    OrgId()
    {
      return this.loggedInUserObj.orgId;
    },
    isSupervisor()
    {
      return this.loggedInUserObj.IsSupervisor
    }
  },
  created()
  {
     setTimeout(() => {
      this.height()
     },600)
  },
  methods:{
    height()
    {
        // let calendarApi = this.$refs.fullCalendar.getApi()
        // if(this.MonthSelected == '06')
        //   calendarApi.setOption('height', 353);
        // else
        //   calendarApi.setOption('height', 298);
    },
    closeTimeSheetsPopover() {
      if(this.showTimeSheetsPopover == true)
        this.showTimeSheetsPopover = false;
    },
    OpenEditEvaluation(event)
    {
          this.selectedEventInfo = event
          this.openEvaluationReport = true
          this.isEdit = true
    },
    onOpenApprovalreport(v,event)
    {
      this.$loading({'loadingText': 'Loading...'})
      this.iframeURL = '' ;
      this.selectedEventInfo = event;
      ajax.get(`TimeSheets/Report/${this.selectedEventInfo.TimesheetId}?employeeId=${this.selectedEventInfo.EmployeeId}`, {} , (res) => {
        if(res.data.State == true){
          this.iframeURL = res.data.ReportUrl ;
          this.CanEvaluate = v ;
          this.openApprovalreport = true
          this.isEdit = false
        }
         this.$loading({}).close()
      })
    },
    openEvaluation()
    {
      this.openEvaluationReport = true
    },
    onTimeSheetApproved(){
      this.refetchEvents()
      this.openEvaluationReport = false
      this.openApprovalreport = false
    },
    refetchEvents()
    {
      this.openEvaluationReport = false
      this.openApprovalreport = false
      this.showTimeSheetsPopover = false
      let calendarApi = this.$refs.fullCalendar.getApi()
      calendarApi.refetchEvents()
    },
 events: function(info, successCallback, failureCallback ) {
      var startDate =  moment(info.start).format("MM/DD/YYYY");
        var monthstartDate =  moment(info.start).add('days', 7).format("MM/DD/YYYY");
        this.$emit('changedDate', monthstartDate);
        var month = moment(monthstartDate).format("MM");
        var year = moment(monthstartDate).format("YYYY");
       this.isLoading = true
        ajax.get(`/TimeSheets/Employee/Monthly/List/${this.EmployeeId}?month=${month}&year=${year}`,{},(res)=>{
          successCallback(
            Array.prototype.slice.call(
              res.data.CalendarList
            ).map(function(eventEl) {
              return {
                id: eventEl.Id,
                title: '',
                start: eventEl.FromDateTime,
                end: eventEl.ToDateTime.replace('T00:00:00Z', 'T23:59:59Z'),
                EventObj : eventEl,
                type:eventEl.CalendarType,
                status:eventEl.Status,
                ExpenseStatus:eventEl.ExpenseStatus,
              }
            })
          )
         this.isLoading = false
        })
    },
    renderEvent()
    {

    },
    gotoDate(year)
    {
      let calendarApi = this.$refs.fullCalendar.getApi()
      calendarApi.gotoDate(year)
    },
    getUrlVars()
    {
        var vars = [], hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for(var i = 0; i < hashes.length; i++)
        {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    },
    dayRender:function(info )
    {

    },
    eventPositioned: function(view) {
    },
    datesRender(info) {
         let weekDays = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
         var i = 0
        jquery(info.el).find('th.fc-day-header.fc-widget-header').each(function() {
                var container = weekDays[i]
                jquery(this).html(container);
                i++;
        });
    },
    eventSelected(event, jsEvent){

    },
    eventClick(info)
    {
      this.eventObj = [];
      if(this.defaultView == 'customViewMonthly') {
        //let parsed = JSON.parse(info[1].defs);
        for(var k = 0 ; k < info.length ; k++)
        {
          if(info[k] != null)
          {
            this.eventObj.push(JSON.parse(info[k].defs));
          }
        }
        setTimeout(() => {
          this.showTimeSheetsPopover = true;
          setTimeout(() => {
            createPopper(info[0].el, this.$refs.timeSheetPopoverWrapper, {
              placement: 'bottom',
            });
          }, 0)
        }, 0)
      } else if(this.defaultView == 'customViewYearly') {
        //let parsed = JSON.parse(info.defs);
        for(var k = 0 ; k < info.length ; k++)
        {
          if(info[k] != null)
          {
            var event = JSON.parse(info[k].defs)
            this.eventObj.push(event.extendedProps.EventObj);
          }
        }
        //this.eventObj = parsed.extendedProps.EventObj;
        setTimeout(() => {
          this.showTimeSheetsPopover = true;
          setTimeout(() => {
            createPopper(info[0].el, this.$refs.timeSheetPopoverWrapper, {
              placement: 'bottom',
            });
          }, 0)
        }, 0)
      }
        else {
          let calendarApi = this.$refs.fullCalendar.getApi()
          var eventList =  calendarApi.getEvents() ;
          var eleme = $.nearest({x: info.jsEvent.pageX, y: info.jsEvent.pageY},'.fc-day');
          var date = eleme.attr("data-date");
          for(let i = 0; i < eventList.length; i++) {
            let c = eventList[i].extendedProps.EventObj
            const range = moment(c.FromDate, 'MM/DD/YYYY').twix(moment(c.ToDate, 'MM/DD/YYYY'), true);
            if(range.contains(moment(date).format('YYYY/MM/DD'))) {
              this.eventObj.push(c);
            }
          }
          setTimeout(() => {
          this.showTimeSheetsPopover = true;
          setTimeout(() => {
            createPopper(info.el, this.$refs.timeSheetPopoverWrapper, {
              placement: 'auto',
            });
          }, 0)
        }, 0);
      }
    },
    eventRender(info) {
     //event,el,view
     console.log(info)
     if(info.event.extendedProps.EventObj.CalendarType == 'TimeSheet' && (info.event.extendedProps.EventObj.Status == 'Approved' && info.event.extendedProps.EventObj.InvoiceStatus == 'Invoice Generated')){
      jquery(info.el).addClass('dashboard-custom-event-background9');
     }
      else if(info.event.extendedProps.EventObj.CalendarType == 'TimeSheet' && (info.event.extendedProps.EventObj.Status == 'Approved' || info.event.extendedProps.EventObj.ExpenseStatus == 'Approved')){
        if((info.event.extendedProps.EventObj.TimesheetlatestLog != null && info.event.extendedProps.EventObj.TimesheetlatestLog.Status == 'EmployeeRequestedForEdit') || (info.event.extendedProps.EventObj.ExpenselatestLog != null && info.event.extendedProps.EventObj.ExpenselatestLog.Status == 'EmployeeRequestedForEdit')){
          jquery(info.el).addClass("dashboard-custom-event-background7");
        }
        else jquery(info.el).addClass('dashboard-custom-event-background1' );
      }
      else if(info.event.extendedProps.EventObj.CalendarType == 'TimeSheet' && (info.event.extendedProps.EventObj.Status == 'Pending' || info.event.extendedProps.EventObj.ExpenseStatus == 'Pending'))
        jquery(info.el).addClass('dashboard-custom-event-background2');
       else if(info.event.extendedProps.EventObj.CalendarType == 'TimeSheet' && (info.event.extendedProps.EventObj.Status == 'Rejected' || info.event.extendedProps.EventObj.ExpenseStatus == 'Rejected'))
        jquery(info.el).addClass('dashboard-custom-event-background6');
      else if(info.event.extendedProps.EventObj.CalendarType == 'Leave' && info.event.extendedProps.EventObj.Status == 'Pending')
        jquery(info.el).addClass('dashboard-custom-event-background4');
      else if(info.event.extendedProps.EventObj.CalendarType == 'Leave' && info.event.extendedProps.EventObj.Status == 'Approved')
        jquery(info.el).addClass('dashboard-custom-event-background3');
      else if(info.event.extendedProps.EventObj.CalendarType == 'Holiday')
        jquery(info.el).addClass('dashboard-custom-event-background5');
      else if (info.event.extendedProps.EventObj.CalendarType == "TimeSheet" && (info.event.extendedProps.EventObj.Status == "Saved" || info.event.extendedProps.EventObj.ExpenseStatus == 'Saved') )
        jquery(info.el).addClass("custom-event-background-timesheet-save");
   	},
     closeEditRequestPopUp(){
      this.reasonForEdit = ""
      this.showRequestForEditPopUp = false
    },
     openRequestForEditPopup(event,type){
      this.TimesheetId = event.Id
      this.empId = event.EmployeeId
      this.showRequestForEditPopUp = true
      this.requestToEditType = type
    },
    RequestToEdit(){
      this.$loading({'loadingText': 'Loading...'}) 
            ajax.put(`TimeSheets/RequestToEdit?id=${this.TimesheetId}&reSubmittedReason=${this.reasonForEdit}&type=${this.requestToEditType}`, {} , (res) => {
            if(res.data.State == true){
              this.reasonForEdit = ""
              let localObj = {
              Id: this.TimesheetId.Id,
              IsPagefullLoad: true,
              EmployeeId: this.empId,
              Status: "Pending",
              type: "Timesheet",
              from: "Popover"
            };
              this.refetchEvents(localObj);
              this.showRequestForEditPopUp = false
              this.$message({
                type: 'success',
                message:this.requestToEditType== 'Timesheet'? 'Timesheet Requested for edit successfully.':'Expense Requested for edit successfully.'
              })
            }
            else{
            this.$message({
                type: 'error',
                message: res.data.Message
                })
            }
            this.$loading({}).close()
        })
    },
  }
}
</script>
<style lang='scss'>
@import "@fullcalendar/core/main.css";
@import "@fullcalendar/daygrid/main.css";
@import "@fullcalendar/timegrid/main.css";

// @import "./CustomViews/main.scss";

.dash-board{

.fc-day-number{
  line-height: 47px !important ;
}
.fc-day-top , .fc-future{
  // padding-right:35px !important ;
}
.fc-day-grid .fc-row {
  height: 55px !important;
}
  .popover-custom-width-leave-Pending{
    border: none;
    -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    -moz-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    min-width: 326px;
  }
 .popover-custom-width-Approved{
    border: none;
    -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    -moz-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    min-width: 440px;
  }
 .popover-custom-width-Pending{
    border: none;
    -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    -moz-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    min-width: 440px;
  }
  .popover-custom-width-holiday{
     border: none;
    -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    -moz-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    width: 180px;
  }
  .dashboard-custom-event-background1{
    height: 33px;
    margin-top: -44px !important;
    border: 1px solid #E7FBF2;
    background: rgba(231,251,242, 0.6);
    border-bottom: 6px solid #13DA7C;
}
.dashboard-custom-event-background9{
    height: 33px;
    margin-top: -44px !important;
    border: 1px solid #E7FBF2;
    background: rgba(231,251,242, 0.6);
    border-bottom: 6px solid #A31D95;
}
.dashboard-custom-event-background2{
    height: 33px;
    margin-top: -44px !important;
    border: 1px solid #FEFAE8;
    background: rgba(254,250,232, 0.6);
    border-bottom: 6px solid #F8D21C;
}
.dashboard-custom-event-background3{
    height: 33px;
    margin-top: -44px !important;
    background: rgba(233,233,252, 0.6);
    border: 1px solid #E9E9FC;
    border-bottom: 6px solid #2027E8;
}
.dashboard-custom-event-background4{
    height: 33px;
    margin-top: -44px !important;
    border: 1px solid #EBEBEB;
    background: rgba(235,235,235, 0.6);
    border-bottom: 6px solid #35373A;
}
.dashboard-custom-event-background5{
    height: 33px;
    margin-top: -44px !important;
     border: 1px solid #EEECE9 !important;
    background:rgba(178,139,97,0.6) !important;
    border-bottom: 6px solid   #B28B61 !important;
}
.dashboard-custom-event-background6{
    height: 33px;
    margin-top: -44px !important;
     border: 1px solid #FDEAE5 !important;
    background:rgba(253,234,229,0.6) !important;
    border-bottom: 6px solid   #EF4457 !important;
}
.dashboard-custom-event-background7{
    height: 33px;
    margin-top: -44px !important;
    border: 1px solid #eee7ff;
    background: rgba(217,226,244, 0.6);
    border-bottom: 6px solid #aa99d6;
}
.custom-event-background-timesheet-save{
    height: 33px;
    margin-top: -44px !important;
    border: 1px solid #FEDCC5 !important;
    background:rgba(254, 220, 197, 0.6) !important;;
    border-bottom: 6px solid   #F96301 !important;
}
.fc-ltr .fc-dayGrid-view .fc-day-top .fc-day-number {
    float: unset;
    display: inline-block;
    margin-left: 15px;
}
 .fc-content{
   margin-top: 38px;
 }
 .fc-content{
   visibility: hidden;
 }
 .fc-today{
    background: none !important;
    border: white !important;
 }
 .fc-day-top{
     border: none !important;
  }
.fc-today .fc-day-number{
    line-height: 15px !important;
    background: #509BEC !important;
    padding-top: -157px;
    border-radius: 129px;
    padding: 5px 4px !important;
    margin-top: 13px;
    border: none !important;
    color: #fff;
}
.ess-dashboard-calendar {
  margin: 0 auto;
}
.fc button
{
  font-weight: 900 !important;
}
.fc-header-toolbar
{
  padding: 10px 10px;
}
.fc-day-header{
    text-transform: uppercase!important;
    font-weight: 800 !important;
    font-size: 12px !important;
    color: #77797d !important;
}
.fc-widget-header{
   background: none!important;
}
.fc-day-number{
    font-weight: 600;
    font-size: 14px;
}
.fc-head{
  border-color:red  !important;
}
.fc td, .fc th {
 border: none;
}
.timesheet-popover-wrapper {
    padding: 10px 1px 2px 1px;
    z-index: 1060;
    max-width: 276px;
    position: absolute;
    background: #fff;
    top: 0;
    font-size: 14px;
    border-radius: 6px;
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
}
thead{
  background-color: #fff !important;
}
  .fc-content-skeleton{
    tr{
      background-color: #fff !important;
    }
  }
}
</style>
<style scoped>
.title{
  color: #19223d;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.5px;
  margin-bottom: 5px;
  margin-right: 4px;
  }
.circle{
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  display: inline-block;
  color:#000000;
  background-color: #000000;
}
.circle1{
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  display: inline-block;
  color:#2027E8;
  background-color:#2027E8;
}
.circle2{
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  display: inline-block;
  color:#13DA7C;
  background-color:#13DA7C;
}
.circle3{
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  display: inline-block;
  color:#F8D21C;
  background-color:#F8D21C;
}
.circle4{
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  display: inline-block;
  color:#EF4457;
  background-color:#EF4457;
}
.circle5 {
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  display: inline-block;
  color: #F96301;
  background-color: #F96301;
}
.add a {
  color: #91959e;
}
.add a:hover {
  color: #337ab7;
}
.dashboardcal-legends{
  text-transform: capitalize;
  font-size: 10px;
  margin:0px;
  font-weight: 600;
}
.legends{
  color: #000000;
  padding-left: 3px;
  padding-right: 3px;
}
.circle6{
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  display: inline-block;
  color:#aa99d6;
  background-color:#aa99d6;
}
.circle7{
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  display: inline-block;
  color:#a31d95;
  background-color:#a31d95;
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/ESSDashboard/DashboardCalender.vue